
import { Component, Vue } from "vue-property-decorator";
import { ProgramPaths } from "@/enum/ProgramPaths";

interface KaynakItem {
  key: string;
  icon: string;
  title: string;
  desc: string;
  cta: string;
  /** Uc urunde de ayni olan adres. */
  url?: string;
  /** Urune ozel adres; varsa `url`i ezer. */
  urls?: Record<string, string>;
}

interface CozulmusKaynak extends KaynakItem {
  link: string;
}

const OGRENIM_KANALI = "https://www.youtube.com/@%C4%B0craProWeb";

interface UrunGorunum {
  isim: string;
  /** Ikonlar + pill buton kenarligi/hover'i */
  accent: string;
  /** Pill buton yazisi */
  text: string;
  /** Pill butonun sakin haldeki kenarligi */
  soft: string;
  /** Pill buton hover zemini */
  tint: string;
}

const URUN_GORUNUM: Record<string, UrunGorunum> = {
  [ProgramPaths.ofispro]: {
    isim: "OfisPro",
    accent: "#8B3FD9",
    text: "#6D28D9",
    soft: "#C4B0F3",
    tint: "#F4EFFF",
  },
  [ProgramPaths.icrapro]: {
    isim: "İcraPro",
    accent: "#1F7AD3",
    text: "#1565C0",
    soft: "#A9CFF0",
    tint: "#EAF4FD",
  },
  [ProgramPaths.eicrapro]: {
    isim: "e-İcraPro",
    accent: "#F08C00",
    text: "#B45309",
    soft: "#F6CB8F",
    tint: "#FFF6EA",
  },
};

@Component({ name: "KaynaklarInfo" })
export default class KaynaklarInfo extends Vue {
  menu = false;

  baseItems: KaynakItem[] = [
    {
      key: "bulten",
      icon: "mdi-play-circle",
      title: "Bülten Videoları",
      desc: "En güncel gelişmeleri video bültenlerimizle izleyin.",
      cta: "Videoları İzle",
      url: "https://www.youtube.com/watch?v=LwFbYrL1mCw",
    },
    {
      key: "blog",
      icon: "mdi-pencil-box",
      title: "Blog Yazıları",
      desc: "Mevzuat, ipuçları ve sektörel yazılarımızı okuyun.",
      cta: "Blog'a Git",
      url: "https://zirve-bilgisayar.com/blog",
    },
    {
      key: "youtube",
      icon: "mdi-youtube",
      title: "YouTube Kanalı",
      desc: "Eğitici içerikler ve program tanıtımları için kanalımız.",
      cta: "YouTube'a Git",
      url: "https://www.youtube.com/@ZirveBilgisayar.%C4%B0craPro/featured",
    },
    {
      key: "tanitim",
      icon: "mdi-monitor",
      title: "Program Tanıtımı",
      desc: "Zirve Cloud {urun} özelliklerini keşfedin.",
      cta: "Tanıtımı İzle",
      urls: {
        [ProgramPaths.ofispro]: "https://www.youtube.com/watch?v=Kd6D8LbHLps&t=113s",
        [ProgramPaths.icrapro]: "https://www.youtube.com/watch?v=XdiDfWsYeGc&t=1389s",
        [ProgramPaths.eicrapro]: "https://www.youtube.com/watch?v=lfXZ__qvy2s",
      },
    },
    {
      key: "ogrenim",
      icon: "mdi-school",
      title: "Öğrenim Videoları",
      desc: "Adım adım kullanım videolarıyla öğrenin.",
      cta: "Videolara Git",
      urls: {
        [ProgramPaths.ofispro]: OGRENIM_KANALI,
        [ProgramPaths.icrapro]: OGRENIM_KANALI,
        [ProgramPaths.eicrapro]: "https://www.youtube.com/@ZirveBilgisayar.%C4%B0craPro",
      },
    },
  ];

  // store.getters.isOfisPro window.location'a bakiyor ve urun degisiminde reaktif degil
  get aktifUrunYolu(): string | undefined {
    return Object.keys(URUN_GORUNUM).find(yol => this.$route.path.startsWith(yol));
  }

  get visible(): boolean {
    return !!this.aktifUrunYolu;
  }

  get gorunum(): UrunGorunum {
    return URUN_GORUNUM[this.aktifUrunYolu ?? ProgramPaths.ofispro];
  }

  get panelStyle(): Record<string, string> {
    return {
      "--kaynak-accent": this.gorunum.accent,
      "--kaynak-text": this.gorunum.text,
      "--kaynak-soft": this.gorunum.soft,
      "--kaynak-tint": this.gorunum.tint,
    };
  }

  get items(): CozulmusKaynak[] {
    const yol = this.aktifUrunYolu ?? ProgramPaths.ofispro;
    return this.baseItems.map(item => ({
      ...item,
      desc: item.desc.replace("{urun}", this.gorunum.isim),
      link: item.urls?.[yol] ?? item.url ?? "",
    }));
  }

  // v-menu konumlandirmayi kendi inline min/max-width'inden hesapliyor; olcuyu
  // sadece CSS'te verirsek dar ekranda paneli viewport disina tasiyor
  get panelWidth(): number {
    return Math.min(940, Math.max(260, this.$vuetify.breakpoint.width - 16));
  }

  git(item: CozulmusKaynak) {
    if (!item.link) return;
    window.open(item.link, "_blank", "noopener,noreferrer");
    this.menu = false;
  }
}
